module.exports = __webpack_public_path__ + "static/media/142302.8cf5a650.jpg";